import { Icon } from './Icon.jsx';

// NOTE: this deliberately does NOT use the class name "toast" — Bootstrap
// ships its own `.toast` component with `.toast:not(.show) { display: none; }`,
// which (being a 2-class selector) beats our plain 1-class `.toast` rule on
// specificity regardless of CSS load order, silently hiding every toast in
// the app once bootstrap.min.css was added as a global import. Using a
// prefixed class name avoids colliding with any current or future Bootstrap
// component class.
export function ToastStack({ toasts }) {
  return (
    <div className="cb-toast-stack">
      {toasts.map((t) => (
        <div key={t.id} className={'cb-toast ' + t.type}>
          <span className="toast-icon">{t.type === 'success' ? <Icon.check /> : <Icon.alert />}</span>
          {t.message}
        </div>
      ))}
    </div>
  );
}
